import { trpc } from '@/shared/api';

/**
 * 운영 설정 공개 조회(siteSettings.getPublic) — 카카오톡 상담 버튼이 쓸 1:1 채팅 주소. 비어 있으면 버튼을 그리지 않는다.
 * 모든 화면이 한 번씩 읽으므로 잠시 캐시하고, 실패해도 되풀이하지 않는다(버튼 하나 때문에 요청을 반복하지 않는다).
 */
export const useSiteSettingsQuery = () =>
  trpc.siteSettings.getPublic.useQuery(undefined, { retry: false, staleTime: 5 * 60_000 });
